import { authService } from '@/services';
import { useHistory } from 'react-router-dom';
import NoAuthTopBar from '@/components/NoAuthTopBar';

const Shell = ({ title, children }) => (
  <div className="flex flex-col items-center w-screen min-h-screen bg-mmj-gray">
    <NoAuthTopBar />
    <div className="w-full max-w-xl mx-auto px-4 py-8 md:py-16">
      <div className="bg-white p-6 md:p-10 rounded-xl shadow-mmj-lg">
        <h1 className="text-2xl md:text-3xl font-bold text-mmj-header mb-4">
          {title}
        </h1>
        {children}
      </div>
    </div>
  </div>
);

export const InvalidIntakeLink = () => {
  const handleSignOut = async () => {
    await authService.logout();
  };
  return (
    <Shell title="This intake link is not valid for your account">
      <p className="text-lg text-mmj-header mb-6">
        The intake form at this link belongs to a different patient. This
        usually means you are signed in with the wrong email, or the link was
        forwarded from someone else.
      </p>
      <p className="text-base text-gray-700 mb-6">
        Sign in with the email you used to book the appointment, or contact us
        at{' '}
        <a className="text-mmj-blue underline" href="mailto:support@MMJ.com">
          support@MMJ.com
        </a>{' '}
        if you believe this is a mistake.
      </p>
      <button
        type="button"
        className="button button-primary w-full"
        style={{ minHeight: '56px', fontSize: '18px' }}
        onClick={handleSignOut}
      >
        Sign out
      </button>
    </Shell>
  );
};

export const IntakeNotFound = () => {
  const history = useHistory();
  return (
    <Shell title="We can't find an intake for this link">
      <p className="text-lg text-mmj-header mb-6">
        The link you used may be old, mistyped, or not associated with a
        scheduled appointment.
      </p>
      <p className="text-base text-gray-700 mb-6">
        Open your dashboard to see your scheduled appointments and any intake
        forms that need your attention.
      </p>
      <button
        type="button"
        className="button button-primary w-full"
        style={{ minHeight: '56px', fontSize: '18px' }}
        onClick={() => history.push('/')}
      >
        Go to my dashboard
      </button>
    </Shell>
  );
};
